import React from 'react';
import { QuoteLabel } from '../Labels';
import { Inner, StyledPercentLabel, Label } from './partials';
export var LastQuote = function LastQuote(_ref) {
  var value = _ref.value,
    currency = _ref.currency,
    label = _ref.label,
    topMargin = _ref.topMargin,
    bottomMargin = _ref.bottomMargin,
    primary = _ref.primary,
    align = _ref.align;
  return React.createElement(Inner, {
    bottomMargin: bottomMargin,
    topMargin: topMargin,
    primary: primary,
    align: align
  }, React.createElement(StyledPercentLabel, null, React.createElement(QuoteLabel, {
    bold: true,
    value: value,
    decimals: 2,
    currency: currency
  })), label && React.createElement(Label, null, label));
};